import React, { useEffect, useContext } from 'react';
import { ASSET_EVENTS } from '../../services/s3-api.service';
import { ActivityContext, ACTIVITY_TYPES, RESOURCE_TYPES } from '../../contexts/ActivityTrackingContext';


function AssetMonitorComponent() {
  const { trackActivity } = useContext(ActivityContext);
  
  useEffect(() => {
    const handleAssetUpload = (event) => {
      try {
        const { key, fileName, path, organizationName, sceneName, type } = event.detail;
        
        // Handle both file uploads and folder creation
        const assetKey = key || path;
        const assetName = fileName || (assetKey ? assetKey.split('/').pop() : 'Unknown');
        
        trackActivity(
          ACTIVITY_TYPES.CREATE,
          RESOURCE_TYPES.ASSET,
          assetKey,
          assetName,
          {
            organization_name: organizationName,
            scene_name: sceneName,
            file_type: event.detail.fileType,
            file_size: event.detail.fileSize,
            type: type || 'file'
          }
        );
      } catch (error) {
        console.error('Error handling asset upload event:', error);
      }
    };
    
    const handleAssetDelete = (event) => {
      try {
        const { key, path, type, organizationName, sceneName } = event.detail;
        console.log('Asset deleted:', event.detail);
        
        // Handle both file and folder deletion
        const assetKey = key || path;
        const assetName = assetKey ? assetKey.split('/').pop() : 'Unknown';
        
        trackActivity(
          ACTIVITY_TYPES.DELETE,
          RESOURCE_TYPES.ASSET,
          assetKey, 
          assetName,
          {
            organization_name: organizationName,
            scene_name: sceneName,
            type: type || 'file'
          }
        );
      } catch (error) {
        console.error('Error handling asset delete event:', error);
      }
    };
    
    document.addEventListener(ASSET_EVENTS.UPLOAD, handleAssetUpload);
    document.addEventListener(ASSET_EVENTS.CREATE, handleAssetUpload);
    document.addEventListener(ASSET_EVENTS.DELETE, handleAssetDelete);
    
    return () => {
      document.removeEventListener(ASSET_EVENTS.UPLOAD, handleAssetUpload);
      document.removeEventListener(ASSET_EVENTS.CREATE, handleAssetUpload);
      document.removeEventListener(ASSET_EVENTS.DELETE, handleAssetDelete);
    };
  }, [trackActivity]);
  
  return null; 
}

export default AssetMonitorComponent;